module.exports = __webpack_public_path__ + "static/media/img-function-new-offer.234bdedb.png";